import {
  UPDATE_TENANT_SETTINGS,
  UPDATE_TENANT_SETTINGS_SUCCESS,
  UPDATE_TENANT_SETTINGS_ERROR,
  RESET_TENANT_SETTINGS_STATUS,
  RESET_TENANT_SETTINGS_ERROR,
  GET_TENANT_SETTINGS,
  GET_TENANT_SETTINGS_SUCCESS,
  GET_TENANT_SETTINGS_ERROR,
} from "./actionTypes";

export const updateTenantSettings = (settings) => {
  return {
    type: UPDATE_TENANT_SETTINGS,
    payload: { settings },
  };
};

export const updateTenantSettingsSuccess = () => {
  return {
    type: UPDATE_TENANT_SETTINGS_SUCCESS,
  };
};

export const updateTenantSettingsError = (error) => {
  return {
    type: UPDATE_TENANT_SETTINGS_ERROR,
    payload: error,
  };
};

export const getTenantSettings = () => {
  return {
    type: GET_TENANT_SETTINGS,
  };
};

export const getTenantSettingsSuccess = (settings) => {
  return {
    type: GET_TENANT_SETTINGS_SUCCESS,
    payload: settings,
  };
};

export const getTenantSettingsError = (error) => {
  return {
    type: GET_TENANT_SETTINGS_ERROR,
    payload: error,
  };
};

export const resetTenantSettingsStatus = () => {
  return {
    type: RESET_TENANT_SETTINGS_STATUS,
  };
};

export const resetTenantSettingsError = () => {
  return {
    type: RESET_TENANT_SETTINGS_ERROR,
  };
};
